<p>
  <a
    href="{{
      toURL(
        item.link_url && item.link_url.value ? item.link_url.value : item.url
      )
    }}"
    target="_blank"
  >
    {{
      item?.link_text?.value || item.text || item?.translation_key
        | translation
        | translationFromString
        | transformText : item?.text_transform
    }}
  </a>
</p>
